import * as React from 'react';

import { BackButton } from '../../components/BackButton';
import { useApplicationContext } from '../../utils/applicationContext';
import { getNewbuildingPromosUrl } from '../../utils/config';

export const BackButtonContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const url = getNewbuildingPromosUrl(config);

  return <BackButton url={url} title="Назад на акции и скидки" />;
};
